<section class="title-holder">
    <div class="container p-4">
        <div class="row">
            <h2 class="text-center w-100">All Properties</h2>
        </div>
    </div>
</section>
<div class="container mt-5 mb-4">
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <p class="filter-text">
                <span class="ml-2 mr-2">Sort Properties:</span>
                <span class="ml-2 mr-2">
                    <select [(ngModel)]="selectedOption" (ngModelChange)="changeFilterValues()" >
                        <option value="price">Cost</option>
                        <option value="date">Date</option>
                    </select>
                </span>
                <span class="ml-2 mr-2">
                    <select [(ngModel)]="selectedFilterOption" (ngModelChange)="getProperties()">
                        <option *ngFor="let option of availableFilterOptions" [value]="option.value"> {{ option.viewValue}} </option>
                    </select>
                </span>
            </p>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="d-flex" *ngIf="properties.length > 0">
                <div class="arrow-holders">
                    <button mat-button (click)="firstPage()" [disabled]="page == 1">
                        <mat-icon>first_page</mat-icon>
                    </button>
                    <button mat-button (click)="previousPage()" [disabled]="page == 1">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <button mat-button disabled>
                        {{ page }} of {{ lastpage }}
                    </button>
                    <button mat-button (click)="nextPage()" [disabled]="page == lastpage">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                    <button mat-button (click)="lastPage()" [disabled]="page == lastpage">
                        <mat-icon>last_page</mat-icon>
                    </button>
                </div>
            </div>
        </div>     
    </div>
</div>
<div class="container" *ngIf="loading">
    <div class="row justify-content-center mt-5 mb-5">
        <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
    </div>
</div>
<div class="container mb-5" *ngIf="!loading">
    <!-- <div class="row mt-4 mb-5 justify-content-center" *ngIf="properties.length > 0">
        <div class="arrow-holders">
            <button mat-button (click)="firstPage()" [disabled]="page == 1">
                <mat-icon>first_page</mat-icon>
            </button>
            <button mat-button (click)="previousPage()" [disabled]="page == 1">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-button disabled>
                {{ page }} of {{ lastpage }}
            </button>
            <button mat-button (click)="nextPage()" [disabled]="page == lastpage">
                <mat-icon>chevron_right</mat-icon>
            </button>
            <button mat-button (click)="lastPage()" [disabled]="page == lastpage">
                <mat-icon>last_page</mat-icon>
            </button>
        </div>
    </div> -->
    <div class="row" *ngIf="properties.length > 0">
        <div class="card mt-1 mb-4 w-100" *ngFor="let property of properties">
            <a [routerLink]="['/property/'+property.id]">
                <!-- <div class="prop-contents">
                    <div class="cont-image">
                        <img [src]="property.featuredImage">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title mb-4">
                            {{ property.title }}
                        </p>
                        <p><img style="display: inline; margin-right: 5px;" src="assets/location_small.png">{{ property.address }}</p>
                        <p class="property-price">रु {{ property.price }}</p>
                    </div>
                </div> -->
                <div class="card-horizontal">
                    <div class="img-square-wrapper">
                        <img *ngIf="property.featuredImage" [src]="property.featuredImage" class="Card image cap w-100 h-100">
                        <img *ngIf="!property.featuredImage" src="assets/placeholder-image.png" class="Card image cap w-100 h-100">
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8 col-sm-12">
                                <h5 class="card-title" (click)="editProperty(property.id)">{{ property.title }}</h5>
                            </div>
                            <div class="col-md-4 col-sm-12" style="font-size: 14px;">
                                <p class="property-price"><strong>रु {{ property.price }}</strong></p>
                            </div>
                        </div>
                        <small><img src="assets/signs.png" style="height: 16px; width: 15px;"> {{ property.address }}</small>
                        <hr class="divider">
                        <div class="row">
                            <div class="col-12" style="font-size: 14px;">
                                <p *ngIf="property.totalArea"><strong>Total Area : </strong> {{ property.totalArea }} (Bigha)</p>
                                <p><strong>Ad Views : </strong> {{ property.totalView }}</p>
                                <p class="m-0"><strong>Posted On : </strong> {{ property.approvalDate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <div class="row mt-5 mb-5" *ngIf="properties.length == 0">
        <h1 class="info-text text-center">No Properies</h1>
    </div>
</div>
<section class="search-holder">
    <div class="container py-5 banner">
        <h2 class="text-center mb-5">Couldn't find what you were looking for? Search Again.</h2>
        <form [formGroup]="searchForm">
            <input type="text" formControlName="keyword" placeholder="Keywords or location">
            <select formControlName="type">
                <option value="null" [selected]="true" disabled>Select Property Type</option>
                <option *ngFor="let type of propertyTypes" [value]="type.id">{{ type.type }}</option>
            </select>
            <select formControlName="listingFor">
                <option value="null" [selected]="true" disabled>Listed For</option>
                <option value="sell">Sell</option>
                <option value="rent">Rent</option>
            </select>
            <button type="button" (click)="search()">Search&nbsp;&nbsp;<img src="assets\search-white.png" style="margin-top: -4px;"></button>
        </form>
    </div>
</section>